import { PauseCircle } from '@crehana/compass.icons.outline/v2/pause-circle';
import { StopCircle } from '@crehana/compass.icons.outline/v2/stop-circle';
import { Button } from '@crehana/compass.ui/v3/button';

import { TimeAttendanceMarkType } from '@/generated/graphql/types';

import { useContextMarkAttendance } from '../context-mark-attendance';
import { useTranslation } from '../i18n';
import type { TWidgetSize } from '../types';

type TActionButtonProps = {
  size: TWidgetSize;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
};

const getButtonSize = (
  size: TWidgetSize,
): React.ComponentProps<typeof Button>['size'] => (size === 'l' ? 'lg' : 'sm');

const getButtonHeight = (size: TWidgetSize) =>
  size === 'l' ? 'tw-h-4.8' : 'tw-h-3.6';

export const ActionButtonMarkEntry = ({
  size,
  disabled,
  variant = 'primary',
}: TActionButtonProps) => {
  const { t } = useTranslation();
  const { markAttendance, mutationLoading } = useContextMarkAttendance();

  return (
    <Button
      type="button"
      variant={variant}
      size={getButtonSize(size)}
      disabled={disabled}
      loading={mutationLoading}
      onClick={() => markAttendance(TimeAttendanceMarkType.Entry)}
      className={getButtonHeight(size)}
    >
      {t('action_buttons_mark_entry')}
    </Button>
  );
};

export const ActionButtonMarkBreakStart = ({
  size,
  disabled,
  variant = 'primary',
}: TActionButtonProps) => {
  const { t } = useTranslation();
  const { markAttendance, mutationLoading } = useContextMarkAttendance();

  return (
    <Button
      type="button"
      variant={variant}
      size={getButtonSize(size)}
      startIcon={PauseCircle}
      disabled={disabled}
      loading={mutationLoading}
      onClick={() => markAttendance(TimeAttendanceMarkType.BreakStart)}
      className={getButtonHeight(size)}
    >
      {t('action_buttons_mark_break_start')}
    </Button>
  );
};

export const ActionButtonMarkBreakEnd = ({
  size,
  disabled,
  variant = 'primary',
}: TActionButtonProps) => {
  const { t } = useTranslation();
  const { markAttendance, mutationLoading } = useContextMarkAttendance();

  return (
    <Button
      type="button"
      variant={variant}
      size={getButtonSize(size)}
      startIcon={PauseCircle}
      disabled={disabled}
      loading={mutationLoading}
      onClick={() => markAttendance(TimeAttendanceMarkType.BreakEnd)}
      className={getButtonHeight(size)}
    >
      {t('action_buttons_mark_break_end')}
    </Button>
  );
};

export const ActionButtonMarkExit = ({
  size,
  disabled,
  variant = 'secondary',
}: TActionButtonProps) => {
  const { t } = useTranslation();
  const { markAttendance, mutationLoading } = useContextMarkAttendance();

  return (
    <Button
      type="button"
      variant={variant}
      size={getButtonSize(size)}
      startIcon={StopCircle}
      disabled={disabled}
      loading={mutationLoading}
      onClick={() => markAttendance(TimeAttendanceMarkType.Exit)}
      className={getButtonHeight(size)}
    >
      {t('action_buttons_mark_exit')}
    </Button>
  );
};
